import axios from 'axios';
import {
   URL_CORE_PRICING_MARKET_LIST_DELETE,
   URL_CORE_PRICING_MARKET_LIST_SAVE,
   URL_CORE_PRICING_MARKET_LIST_SEARCH,
} from '../../../end-points';
import { NOTIFICATION_MESSAGES } from '../../../utils/notification-messages';
import { toastSuccess, toastWarn } from '../../../utils/toasts';

function validateEmptyValues(value) {
   const isArray = Array.isArray(value);
   return isArray ? value.join(',').length > 0 : value.length > 0;
}

const getOperatorValue = (operator) => (operator === '==' ? '==' : operator);

export function getMarketListPayload(queryObject) {
   const marketListSection = queryObject?.find(
      (section) => section.categoryName === 'Market List'
   );

   const marketListQueryFields = marketListSection?.categoryDetails?.filter(
      ({ values }) => validateEmptyValues(values)
   );

   const marketListPayload = marketListQueryFields.map((field) => {
      return {
         key: field.key,
         value: field.values.join(','),
         operator: getOperatorValue(field.operator),
      };
   });

   return marketListPayload;
}

export const fetchMarketList = async (payload) => {
   try {
      const response = await axios.post(
         URL_CORE_PRICING_MARKET_LIST_SEARCH,
         payload,
         {
            headers: {
               'content-type': 'application/json',
            },
         }
      );

      if (response.status !== 200) {
         toastWarn(response.data.message);
         return [];
      }
      toastSuccess(NOTIFICATION_MESSAGES.SEARCH_COMPLETED)
      return response?.data;
   } catch (error) {
      console.warn('Error in fetching Market List records', error);
      toastWarn(error.message);
      return [];
   }
};

export async function saveChanges(payload, rowData) {
   try {
      const response = await axios.post(
         URL_CORE_PRICING_MARKET_LIST_SAVE,
         payload,
         {
            headers: {
               'content-type': 'application/json',
            },
         }
      );

      if (response.status === 200) {
         const updatedRowsMap = new Map(
            response.data.map((row) => [row.id, row])
         );

         payload.forEach(({ rowIndex }) => {
            const currentRow = rowData[rowIndex];
            if (!currentRow) return;

            const updatedRow = updatedRowsMap.get(currentRow.id);
            if (updatedRow) {
               rowData[rowIndex] = updatedRow;
            }
         });

         toastSuccess(NOTIFICATION_MESSAGES.CHANGES_SAVED_SUCCESSFULLY);
         return rowData;
      } else {
         toastWarn(NOTIFICATION_MESSAGES.FAILED_TO_SAVE_CHANGES);
         return rowData;
      }
   } catch (error) {
      console.warn('Error in saving Market List records', error);
      toastWarn(error.message);
      return rowData;
   }
}

export async function deleteSelectedRows(payload) {
   try {
      const response = await axios.delete(URL_CORE_PRICING_MARKET_LIST_DELETE, {
         headers: {
            'content-type': 'application/json',
         },
         data: payload,
      });

      if (response.status === 200) {
         toastSuccess(NOTIFICATION_MESSAGES.RECORD_DELETE_SUCCESS);
      } else {
         toastWarn(response.data.message);
      }
   } catch (error) {
      console.warn('Error in deleting Market List records', error);
      toastWarn(error.message);
   }
}

export const CUSTOM_CONTEXT_MENU_CONFIG = {
   enableInsertNewRow: true,
   enableDelete: true,
   enableInsertTemplate: true,
   enableSave: true,
   enablePaste: true,
   enableCopy: true,
   enableCopyWithHeaders: true,
   enableExportData: true,
   preventDefaultRowDeletion: true,
   saveDataCallback: saveChanges,
};

export const CUSTOM_CONTEXT_MENU_CONFIG_FOR_EMPTY_DATASET = {
   enableInsertNewRow: true,
   enableDelete: false,
   enableInsertTemplate: false,
   enableSave: true,
   enablePaste: true,
   enableCopy: false,
   enableCopyWithHeaders: false,
   enableExportData: false,
   saveDataCallback: saveChanges,
   deleteDataCallback: () => {},
};

export function getContextMenuConfig(rowData) {
   return rowData.length > 0
      ? CUSTOM_CONTEXT_MENU_CONFIG
      : CUSTOM_CONTEXT_MENU_CONFIG_FOR_EMPTY_DATASET;
}
